import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import 'swiper/css';

export default function setupHomeNewsCarousel() {
    const carousels = document.querySelectorAll('.js-home-news-carousel');

    carousels.forEach((carousel) => {
        const section = carousel.closest('.home-news');
        const previousButton = section?.querySelector('.js-home-news-prev');
        const nextButton = section?.querySelector('.js-home-news-next');
        const slideCount = carousel.querySelectorAll('.swiper-slide').length;

        if (!section || !previousButton || !nextButton) {
            return;
        }

        if (slideCount <= 1) {
            section.classList.add('home-news--static');
        }

        new Swiper(carousel, {
            modules: [A11y, Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 650,
            watchOverflow: true,
            navigation: {
                prevEl: previousButton,
                nextEl: nextButton
            },
            a11y: {
                prevSlideMessage: 'Previous latest submission or news item',
                nextSlideMessage: 'Next latest submission or news item'
            },
            breakpoints: {
                560: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 32
                },
                1600: {
                    slidesPerView: 5,
                    spaceBetween: 32
                }
            }
        });
    });
}
